import React, { useState, useEffect } from "react";
import firestore from "../../firebase.config";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Title from "./Title";

const useStyles = makeStyles({
    depositContext: {
        flex: 1,
    },
});

export default function Summary() {
    const [totalUser, setTotalUsers] = useState([]);
    const [totalVideo, setTotalVideos] = useState([]);
    const classes = useStyles();

    // fetch all users
    const fetchUsers = async () => {
        const data = await firestore.collection("users").get();
        setTotalUsers(data.docs.length);
    };

    const fetchVideos = async () => {
        const data = await firestore.collection("videos").get();
        setTotalVideos(data.docs.length);
    };

    useEffect(() => {
        fetchUsers();
        fetchVideos();
    }, []);

    return (
        <React.Fragment>
            <Title>Active Users</Title>
            <Typography component="p" variant="h4">
                {totalUser}
            </Typography>
            <Typography
                color="textSecondary"
                className={classes.depositContext}
            >
                on {new Date().getDay()} / {new Date().getMonth()} /{" "}
                {new Date().getFullYear()}
            </Typography>
            <div>
                <Typography component="p" variant="h4">
                    {totalVideo}
                </Typography>
                <Title>Videos in system</Title>
            </div>
        </React.Fragment>
    );
}
